import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Upload, X, Loader2 } from "lucide-react";

export function ImageUpload({ value, onChange, testid = "image-upload" }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
      toast.success("Imagem enviada!");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Falha ao enviar imagem.");
    } finally { setBusy(false); if (ref.current) ref.current.value = ""; }
  };

  return (
    <div className="flex items-start gap-3" data-testid={testid}>
      {value ? (
        <div className="relative shrink-0">
          <img src={value} alt="" className="w-24 h-16 object-cover rounded-lg border border-white/10" data-testid={`${testid}-preview`} />
          <button type="button" onClick={() => onChange(null)} data-testid={`${testid}-remove`}
            className="absolute -top-2 -right-2 p-1 rounded-full bg-red-500 text-white"><X className="w-3 h-3" /></button>
        </div>
      ) : (
        <div className="w-24 h-16 shrink-0 rounded-lg border border-dashed border-white/15 flex items-center justify-center text-gray-600 text-xs">Sem foto</div>
      )}
      <div className="flex-1 space-y-2">
        <button type="button" disabled={busy} onClick={() => ref.current?.click()} data-testid={`${testid}-btn`}
          className="inline-flex items-center gap-2 text-sm px-3 py-2 rounded-lg bg-cyan-400/10 text-cyan-300 border border-cyan-400/30 hover:bg-cyan-400/20 disabled:opacity-50">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} {busy ? "Enviando..." : "Enviar foto"}
        </button>
        <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden"
          onChange={(e) => send(e.target.files?.[0])} data-testid={`${testid}-input`} />
        <input value={value || ""} onChange={(e) => onChange(e.target.value)} placeholder="ou cole a URL da imagem"
          className="w-full bg-[#0B0F17] border border-white/10 rounded-lg px-3 py-2 outline-none text-xs text-gray-400" data-testid={`${testid}-url`} />
      </div>
    </div>
  );
}
